import { IconThumbsUpRed } from 'assets/icons';
import { device } from 'styles/breakpoints';
import { ActionButton } from 'styles/global.styles';
import { theme } from 'styles/theme';

import ImageIcon from 'components/Icon/ImageIcon';
import styled from 'styled-components';

export interface ISegment {
  title: string;
  selected: boolean;
}
interface ISegmentCard extends ISegment {
  onClick?: () => void;
}

interface ISegmentList {
  data?: ISegment[];
  onSelect: (index: number) => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
}

const SegmentCard = ({ title, selected, onClick }: ISegmentCard): JSX.Element => {
  return (
    <Card role="button" onClick={onClick} $selected={selected}>
      <ThumbsUp $visible={selected} src={IconThumbsUpRed} alt="Segment thumbs up icon" />
      <Title $selected={selected}>{title}</Title>
    </Card>
  );
};

export const Segments = (props: ISegmentList): JSX.Element => {
  return (
    <>
      <Wrapper>
        {props.data?.map((segment, index) => (
          <SegmentCard
            key={index}
            title={segment.title}
            selected={segment.selected}
            onClick={() => props.onSelect(index)}
          />
        ))}
      </Wrapper>

      <ActionButton disabled={props.disabled} onClick={props.onClick}>
        Fortsätt
      </ActionButton>
    </>
  );
};

export default Segments;

const Wrapper = styled.div`
  display: grid;
  gap: ${theme.columns.gap};
  grid-template-columns: unset;
  grid-template-rows: repeat(${theme.segments.rows}, 1fr);

  width: 80%;

  @media ${device.xsm} {
    width: auto;
    margin: 0;
  }

  @media ${device.lg} {
    grid-template-columns: repeat(${theme.segments.columns}, 1fr);
    grid-template-rows: unset;
  }
`;

const Card = styled.div<{ $selected?: boolean }>`
  cursor: pointer;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  gap: ${theme.columns.gap};
  background-color: ${theme.colors.secondary};
  border-radius: ${theme.dimensions.components.borderRadius};
  transition: border 0.3s ease-in-out;

  margin: 0 auto;
  padding: 0 1rem;
  width: 100%;
  height: 150px;

  @media ${device.xsm} {
    width: calc(
      ${parseInt(theme.dimensions.card.width) / theme.segments.columns -
      parseInt(theme.columns.gap)}px
    );
    height: calc(${parseInt(theme.dimensions.card.width) / 4 - parseInt(theme.columns.gap)}px);
  }

  border: 2px solid ${({ $selected }) => ($selected ? `${theme.colors.primary}` : 'transparent')};

  &:hover {
    border: 2px solid
      ${({ $selected }) => ($selected ? `${theme.colors.primary}` : `${theme.colors.grayscale}`)};
  }

  &:not(:hover) {
    border: 2px solid ${({ $selected }) => ($selected ? `${theme.colors.primary}` : 'transparent')};
  }
`;

const Title = styled.span<{ $selected: boolean }>`
  font-weight: 600;
  font-size: 1rem;

  color: ${({ $selected }) =>
    $selected ? `${theme.colors.primary}` : `${theme.colors.grayscale}`};
  transform: ${({ $selected }) => ($selected ? 'translateY(75%)' : 'translateY(0)')};
  transition:
    color 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

const ThumbsUp = styled(ImageIcon)<{ $visible: boolean }>`
  height: 40px;
  position: absolute;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transform: ${({ $visible }) => ($visible ? 'translateY(-45%)' : 'translateY(10%)')};
  transition:
    transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    opacity 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;
